/**
 * permissive format validation with length checking
 * @param string email 
 */
export function isValidEmail(email) {
  const expression = /^[a-z0-9._%+-]{1,64}@[a-z0-9.-]{2,63}\.[a-z]{2,63}$/i;
  return expression.test(email);
}
